export default {
    'footer.link.termsOfService': 'Terms of Service',
    'footer.link.privacyPolicy': 'Privacy Policy',
    'footer.link.support': 'Support',
    'footer.link.contacts': 'Contacts',
    'footer.copyright': '© 2025 GORILLA ENTERTAINMENT PTE. LTD. All Rights Reserved.',
    'footer.relationship':'Gorilla Studio is a key studio within the Crazy Maple Studio publishing family.'
};
